
export const NOTION_DATABASE_ID = '1d2e21e1f5118044b82ce32c8f247af7';
export const CLIENT_PROFILES_DATABASE_ID = '1d1e21e1f5118092995cf40a3ecf1890';

export const triggerNotionCloneWebhook = async (userId: string, context: string): Promise<string | null> => {
  try {
    // Production webhook URL
    const baseUrl = 'https://goldagent.app.n8n.cloud/webhook/clone-notion-page';
    
    // Create URL with parameters
    const webhookUrl = `${baseUrl}?user_id=${encodeURIComponent(userId)}&parent_id=${encodeURIComponent(CLIENT_PROFILES_DATABASE_ID)}&context=${encodeURIComponent(context)}`;
    
    console.log('Triggering n8n webhook for cloning Notion page:', webhookUrl);
    
    // Make the fetch request
    const response = await fetch(webhookUrl, {
      method: 'GET'
    });
    
    if (response.ok) {
      try {
        const data = await response.json();
        console.log('Webhook response data:', data);
        
        // If data contains a url property (as seen in the network logs), return it
        if (data && data.url) {
          return data.url;
        }
        
        // Alternatively, check for the Notion page URL in the response
        if (data && data.properties && data.url) {
          console.log('Returning Notion page URL from response data:', data.url);
          return data.url;
        }
      } catch (error) {
        console.error('Error parsing webhook response JSON:', error);
      }
    } else {
      console.error('Webhook request failed with status:', response.status);
    }
    
    return null;
  } catch (error) {
    console.error('Error triggering n8n webhook:', error);
    return null;
  }
};
